import { FC, MouseEvent } from 'react';

import { Box } from '@mui/material';

import { AnalyticEventAction } from 'analytics';
import { trackActionButtonAnalyticsEvent } from 'analytics/events/action-button';

import { observer } from 'mobx-react';

import { useStores } from 'mobx/hooks/useStores';

import Ticket from 'models/Ticket';

import { useMessagingQuickActionVisibility } from 'hooks/useMessagingQuickActionVisibility';

import Icon from 'components/Icons/Icon';
import { SimpleTooltip } from 'components/Tooltip';

import { QuickActionContainer } from './QuickActionContainer';

type Props = {
  ticket: Ticket;
  ticketIndex: number;
  ticketSectionCurrentPage: number;
  toggle: () => void;
  isExpanded: boolean;
};

export const MessageQuickAction: FC<Props> = observer(
  ({ ticket, ticketIndex, ticketSectionCurrentPage, toggle, isExpanded }) => {
    const { ticketsStore } = useStores();
    const isVisible = useMessagingQuickActionVisibility(ticket);

    if (!isVisible) {
      return null;
    }

    const handleClick = (event: MouseEvent) => {
      event.stopPropagation();

      // Track analytics
      trackActionButtonAnalyticsEvent({
        action: AnalyticEventAction.MessagePatient,
        patient_id: ticket.patientId,
        ticket_id: ticket.id,
        item_index: ticketIndex + 1,
        page_number: ticketSectionCurrentPage + 1
      });

      toggle();

      if (!isExpanded)
        // Trigger focus for this specific ticket's messaging input
        ticketsStore.focusMessagingInput(ticket.id);
    };

    return (
      <SimpleTooltip
        shouldTruncate={false}
        title={<Box p={8}>Message Patient</Box>}
        placement="top"
      >
        <QuickActionContainer
          onClick={handleClick}
          data-test-hook={`message-quick-action-${ticket.id}`}
        >
          <Icon.MessageGradient />
        </QuickActionContainer>
      </SimpleTooltip>
    );
  }
);
